<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="650px"
    bodyHeight="400px"
    class="edit-imgWrap-modal"
    @close="onChange"
  >
    <div slot="title">
      {{ $t('shop-site::facebook_campaign::bind_title') }}
    </div>
    <div class="img-box">
      <div class="item-cell" v-for="item in images" :key="item.id">
        <el-image :src="item.img || defaultImg" class="img"></el-image>
        <div class="cell-hover">
          <el-button type="text" @click="handleItem('edit', item)">
            <i class="iconfont iconedit edit-icon"></i>
          </el-button>
        </div>
      </div>
      <div class="add-img-item item-cell" @click="handleItem('add')">
        <div class="content">
          <span>+</span>
          <div class="title">{{ $t('shop-site::facebook_campaign::upload_title') }}</div>
        </div>
      </div>
    </div>
    <campaignItemModal v-model="campaignVisable" :drawRow="cellItem" @save="onSaveItem"></campaignItemModal>
  </el-dialog>
</template>
<script>
import campaignItemModal from './campaign-item-modal'
import { accountOptimizingList } from '@/server/marketing.js'
export default {
  name: 'modal-back-email',
  components: {
    campaignItemModal
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      if (bool) {
        this.getOptimizingList()
      }
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      defaultImg: require('@/assets/images/icon_head@2x.png'),
      loading: false,
      campaignVisable: false,
      cellItem: {
        type: 'add',
        item: null
      },
      images: [],
      rules: {
        shopId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
        faceId: [
          { required: true, message: '请输入账号ID', trigger: 'change' },
          { required: true, type: 'number', message: '请输入数字', trigger: 'change' }
        ],
        name: [{ required: true, message: '请输入账号名称', trigger: 'change' }],
        token: [{ required: true, message: '请选择Token配置', trigger: 'change' }]
      },
      show: false,
      params: {}
    }
  },
  mounted() {},
  methods: {
    async getOptimizingList() {
      this.loading = true
      const { data } = await accountOptimizingList({
        pageNum: 1,
        pageSize: 1000,
      })
      if (data.code === this.$code) {
        this.images = data.data
      }
      this.loading = false
    },
    onChange() {
      this.$emit('change', false)
    },

    handleItem(type, row) {
      this.cellItem.type = type
      if (row) {
        this.cellItem.item = row
      }
      this.campaignVisable = true
    },
    onSaveItem(data) {
      this.getOptimizingList()
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-imgWrap-modal {
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .img-box {
    display: flex;
    flex-wrap: wrap;
    .add-img-item {
      width: 100px;
      height: 100px;
      margin-right: 8px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      color: #3a416f;

      .content {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 40px;
        .title {
          font-size: 14px;
        }
      }
    }
    .item-cell {
      width: 100px;
      height: 100px;
      position: relative;
      flex: 0 0 auto;
      margin-right: 12px;
      margin-bottom: 12px;
      .img {
        width: 100px;
        height: 100px;
      }
      .cell-hover {
        display: none;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        align-items: center;
        justify-content: center;
      }
      &:hover {
        .cell-hover {
          display: flex;
        }
      }
      .edit-icon {
        font-size: 22px;
      }
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
